import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface CardWrapperProps {
  id?: string
  children: React.ReactNode
  title: string
  subtitle: string
}

export const CardWrapper = ({
  id,
  children,
  title,
  subtitle,
}: CardWrapperProps): JSX.Element => {  
  return (
    <S.Container id={id}>
      <S.WrapperTitle>
        <Typography weight='bold' variant="content1">{title}</Typography>
        <Typography customClassName='subtitle' variant="content3">{subtitle}</Typography>
      </S.WrapperTitle>
      {children}
    </S.Container>
  )
}